import {Component, Input, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {MapInfoWindow, MapMarker} from '@angular/google-maps';

@Component({
    selector: 'app-map-slice[latitude][longitude]',
    templateUrl: './map-slice.component.html',
    styleUrls: ['./map-slice.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MapSliceComponent implements OnInit {

  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;

  @Input() latitude: number;
  @Input() longitude: number;
  @Input() markerTitle: string;

  center: google.maps.LatLngLiteral;

  constructor() {
  }

  ngOnInit(): void {
    const theLat = this.latitude;
    const theLon = this.longitude;
    this.center = {lat: theLat, lng: theLon};
  }

  openInfoWindow(marker: MapMarker): void {
    this.infoWindow.open(marker);
  }
}
